// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f802be0d","239":"1779d23e","732":"f602f4d0"}[chunkId] + ".chunk.js";
};